<template>
  <div class="formDiv">
    <el-form class="formBox" :model="formData" :rules="rules" ref="infoForm" label-width="130px" style="text-align: left">
      <el-form-item label="公司简称：" prop="tenantname">
        <el-input v-model="formData.tenantname" maxlength="50" show-word-limit @change="showtitle"></el-input>
      </el-form-item>
      <!--<el-form-item label="公司地址：" prop="province">-->
        <!--<v-distpicker :province="formData.province" @province="onChangeProvince" :city="formData.city"-->
                      <!--@city="onChangeCity" :area="formData.county" @area="onChangeArea"-->
        <!--&gt;</v-distpicker>-->
      <!--</el-form-item>-->
      <!--<el-form-item prop="officeaddress">-->
        <!--<el-input v-model="formData.officeaddress" placeholder="详细地址"  maxlength="30" show-word-limit></el-input>-->
      <!--</el-form-item>-->
      <el-form-item label="老板姓名：" prop="contactname">
        <el-input v-model="formData.contactname" maxlength="5" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="联系电话：" prop="contactphone">
        <el-input v-model="formData.contactphone" disabled></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

  import {detailTenantid, saveTenantid} from '@/api/sysmanage/register';

export default {
  data() {
    return {
      formData: {
        tenantname: '',
        contactname: '',
        contactphone: '',
      },
      oldData:{

      },
      rules: {
        tenantname: [
          {required: true, message: '请输入公司简称', trigger: 'blur'},
          {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'},
        ],
        // province: [{required: true, message: '请选择省市县', trigger: 'blur'}],
        // officeaddress: [
        //   {required: true, message: '请填写详细地址', trigger: 'blur'},
        //   {min: 3, max: 30, message: '长度在 3 到 30 个字符', trigger: 'blur'},
        // ],
        contactname: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
          {min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur'},
        ],
      },
    }
  },
  methods: {
    // onChangeProvince(data) {
    //   if (data.value == '省') data.value = '';
    //   this.formData.province = data.value;
    // },
    // onChangeCity(data) {
    //   if (data.value == '市') data.value = '';
    //   this.formData.city = data.value;
    // },
    // onChangeArea(data) {
    //   if (data.value == '区' || data.value == '县') data.value = '';
    //   this.formData.county = data.value;
    // },
    prevFn() {
      this.$emit('update:parentData', this.formData);
    },
    finishFn(callback) {
      // if (!this.formData.city)
      //   this.formData.city = '';
      // if (!this.formData.county)
      //   this.formData.county = '';

      this.$refs.infoForm.validate(valid => {
        if (valid) {
          // this.formData.area = JSON.stringify({
          //   province: this.formData.province,
          //   city: this.formData.city,
          //   county: this.formData.county
          // })

          var hasChange = false;
          for (let key in this.oldData) {
            if (this.oldData[key] != this.formData[key]) {
              hasChange = true;
              break;
            }
          }
          if (!hasChange) {//未修改直接跳过
            callback(true);
            return;
          }

          // this.formData.officeaddress = this.formData.officeaddress.replace(this.formData.province, '').replace(this.formData.city, '').replace(this.formData.county, '')
          saveTenantid(this.formData).then(response => {
            if (response.data.code == 0) {
              localStorage.setItem("hpapi_userInfoModel", JSON.stringify(response.data.obj));
              callback(true);
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
              callback(false);
            }
          });
        } else {
          callback(false);
          return false;
        }
      });
    },
    showtitle(){
      document.title = this.formData.tenantname;
    }
  },
  mounted() {//第一次加载，取公司信息
    detailTenantid().then(response => {
      this.formData = response.data.obj;
      if (this.formData.tenantname == this.formData.contactphone)
        this.formData.tenantname = '';
      if (this.formData.contactname == this.formData.contactphone)
        this.formData.contactname = '';
      // if(this.formData.area){
      //   var area=JSON.parse(this.formData.area);
      //   this.formData.province=area.province;
      //   this.formData.city=area.city;
      //   this.formData.county=area.county;
      // }else{
      //   this.formData.province='';
      //   this.formData.city='';
      //   this.formData.county='';
      // }
      // if(!this.formData.officeaddress){
      //   this.formData.officeaddress='';
      // }
      this.oldData = {}
      for (let key in this.formData) {
        this.oldData[key] = this.formData[key];
      }
      this.showtitle();
    });
  },
}
</script>




// WEBPACK FOOTER //
// src/views/childComp/CompanyInfo.vue